var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import * as SCMP from "../../../../components";
import { BetFinishedFrame } from "../BetFinishedFrame";
import { BetProgress } from "../BetProgress";
var OpenPulseBet = /** @class */ (function (_super) {
    __extends(OpenPulseBet, _super);
    function OpenPulseBet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpenPulseBet.prototype.renderWinnings = function (winningsData) {
        return (React.createElement(SCMP.Winnings, { inputData: winningsData, onStakeChangeFading: false }));
    };
    OpenPulseBet.prototype.componentDidMount = function () {
        this.props.calculateState();
    };
    OpenPulseBet.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "rj-my-pulse-bets__bet-wrapper" },
            React.createElement("div", { className: "rj-my-pulse-bets__bet-wrapper-inner" },
                this.renderWinnings(this.props.viewModel.winningsData),
                React.createElement(BetProgress, { colors: this.props.viewModel.trackColor, segments: this.props.viewModel.pulseBetProgressData, isProgressFinished: this.props.viewModel.isBetExpired(), isGameInProgress: this.props.isGameRunning, callbacks: this.props.callbacks })),
            this.props.viewModel.isFinished &&
                React.createElement(BetFinishedFrame, { won: this.props.viewModel.finishedState && this.props.viewModel.finishedState.status && this.props.viewModel.finishedState.status.won, actions: { text: "string", handler: function () { } }, goMsg: this.props.goMsg, winMsg: this.props.winMsg, removeBetHandler: function () { return _this.props.viewModel.backToBetPlacementHandler(_this.props.viewModel); } })));
    };
    OpenPulseBet = __decorate([
        observer
    ], OpenPulseBet);
    return OpenPulseBet;
}(React.Component));
export { OpenPulseBet };
//# sourceMappingURL=OpenPulseBet.js.map